import { gpCommon } from '../app';
import { IUibModalInstance, ModalService } from '../services/bootstrap-ui-modal';
import { LoginService } from '../services/login-service';
import loginDialogTemplate from './login-dialog.html';

export interface gpLoginDialogResult {
    username: string;
    password: string;
}

interface gpLoginDialogOptions {
    title: string;
    mainInstruction: string;
    existingUsername: string;
}

interface ILoginDialogScope extends ng.IScope {
    errors: any;
    title: string;
    mainInstruction: string;
    existingUsername: string;
    username: string;
    password: string;
    ok: () => void;
    cancel: () => void;
}

gpCommon.controller('gpLoginDialog', ['$scope', '$uibModalInstance', 'options',
    function ($scope: ILoginDialogScope, $uibModalInstance: IUibModalInstance<gpLoginDialogResult>, options: gpLoginDialogOptions) {

    $scope.errors = {};

    $scope.title = options.title;
    $scope.mainInstruction = options.mainInstruction;
    $scope.existingUsername = options.existingUsername;
    $scope.username = options.existingUsername;

    $scope.ok = () => $uibModalInstance.close({ username: $scope.username, password: $scope.password });
    $scope.cancel = () => $uibModalInstance.dismiss("cancelled");

}]);

export class LoginDialogService {
    static $inject = ['gpModal', '$timeout', 'gpLoginService'];

    constructor(
        private readonly modalService: ModalService,
        private readonly $timeout: ng.ITimeoutService,
        private readonly gpLoginService: LoginService) {
    }

    show(title: string, mainInstruction: string, existingUsername: string): ng.IPromise<gpLoginDialogResult> {

        let dialogClosed = false;

        const modalInstance = this.modalService.open<gpLoginDialogResult>({
            animation: true,
            template: loginDialogTemplate,
            controller: 'gpLoginDialog',
            backdrop: 'static',
            backdropClass: 'gameplan-login-dialog',
            windowClass: 'gameplan-login-dialog',
            resolve: {
                options: (): gpLoginDialogOptions => ({
                    title: title,
                    mainInstruction: mainInstruction,
                    existingUsername: existingUsername,
                }),
            },
        });

        // keep checking to see if our login credentials have changed.
        const originalToken = this.gpLoginService.currentToken();

        const checkTokenChangeAndRepeat = () => {
            const currentToken = this.gpLoginService.currentToken();

            if (currentToken !== originalToken) {
                modalInstance.dismiss("cancelled");
            }

            if (!dialogClosed) {
                this.$timeout(() => checkTokenChangeAndRepeat(), 1000);
            }
        }

        this.$timeout(() => checkTokenChangeAndRepeat(), 1000);

        modalInstance.result.finally(() => dialogClosed = true);

        return modalInstance.result;
    }

}

gpCommon.service('gpLoginDialogService', LoginDialogService);

